import { isDynamicFieldValid, isDynamicTableFieldDataValid, FIELD_TYPES } from '../utils/utils';
import React, { useEffect, useState, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import dayjs from "../../../../util/dayjs-config";
import { Form, Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FluentDatePicker } from '../../../FluentUI/Fluent-DatePicker';
import { getDefaultPlaceholderForFieldType } from '../../../../pages/admin/scenes/task-types/dynamic-fields/dynamic-fields-panel/components/admin-dynamic-fields-template';
import CustomFileDropZone from '../../CustomFileDropZone/CustomFileDropZone';
import { TriyoForm } from '../../../TriyoForm';
import { createNewDynamicTableRowHandler, deleteDynamicTableRowHandler } from '../utils/fieldsUtils';
import FilterSortPanel from '../../../../components/filter-sort-panel/filter-sort-panel';
import DropdownIcon from '../../../../assets/icons/Icon - Chevron - Down - Black.svg';
import { LoginContext } from '../../../../services/api/authentication-api';
import "../../../../pages/admin/scenes/task-types/dynamic-fields/dynamic-fields-panel/admin-dynamic-fields-panel.scss";

// Required props:
// {
//      field: DynamicFieldDto
//      handleChange: (e) => void
//      disableErrors: boolean
// }

const TaskDynamicFieldsInput = (props) => {
    const { field, handleChange, disableErrors, disabled, isFromCreate, setDynamicFields, taskWithWorkflow = [], disabledAddDelete, isForm = false } = props;
    const { Data, FieldType, LookupValues, Placeholder, touched } = field;
    const isInvalid = !disableErrors && touched && !isDynamicFieldValid(field) && !isFromCreate;
    const user = useContext(LoginContext);

    const [activeFilterType, setActiveFilterType] = useState([]);
    const [activeFilterValues, setActiveFilterValues] = useState([]);
    const [activeSortType, setActiveSortType] = useState('');

    const [isDescendingSort, setIsDescendingSort] = useState(false);
    const [filteredSortedData, setFilteredSortedData] = useState([]);
    const [selectedFilterRows, setSelectedFilterRows] = useState([]); //The filters we have applied

    useEffect(() => {
        if (FieldType == FIELD_TYPES.table) {
            if (field.Table.Rows == null) {
                addRow(field);
                setFilteredSortedData([])
            }
            else if (field.Table.Rows.length === 0 && (filteredSortedData?.length > 0 || activeFilterType.length > 0 || activeSortType !== '')) {
                setFilteredSortedData([]);
                setActiveFilterType([]);
                setActiveFilterValues([]);
                setSelectedFilterRows([]);
                setActiveSortType('');
                setIsDescendingSort(false);
            }
            else if (filteredSortedData?.length === 0) {
                setFilteredSortedData(field.Table.Rows);
            }
            const clearFiltersButton = document.getElementById('clearFilters-' + field.Id);
            if (clearFiltersButton) {
                clearFiltersButton.onclick = clearAllFilters;
            }
        }
    }, [FieldType, field]);

    useEffect(() => {
        setGeneralFilterButton();
    }, [activeFilterType, activeSortType]);

    const disableScroll = useCallback(() => {
        const { documentElement: html, body } = document;

        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';

        for (const modal of document.getElementsByClassName('modal')) {
            modal.style.overflow = 'hidden';
        }
    }, []);

    const enableScroll = useCallback(() => {
        const { documentElement: html, body } = document;

        html.style.overflow = '';
        body.style.overflow = '';

        for (const modal of document.getElementsByClassName('modal')) {
            modal.style.overflow = '';
        }
    }, []);

    const updateFilter = (selectedRows, type) => {

        setSelectedFilterRows([...selectedFilterRows.filter(r => r.Type !== type), { Type: type, selectedRows: selectedRows }]);
        setActiveFilterType([...activeFilterType.filter(f => f !== type), type]);
    }

    const clearAllFilters = () => {
        setActiveFilterType([]);
        setActiveFilterValues([]);
        setSelectedFilterRows([]);
        setActiveSortType('');
        changeData(undefined, undefined, false);
    }

    const clearFilter = (type) => {
        setActiveFilterType(activeFilterType.filter(f => f !== type));
        setActiveFilterValues(activeFilterValues.filter(f => f.column !== type));
        setSelectedFilterRows(selectedFilterRows.filter(r => r.Type !== type));

        let sortCol = activeSortType;
        let isDesc = isDescendingSort;
        if (activeSortType === type) {
            setActiveSortType('');
            sortCol = '';
            setIsDescendingSort(false);
            isDesc = false;
        }
        changeData(activeFilterValues.filter(f => f.column !== type), sortCol, isDesc);
    }

    const setGeneralFilterButton = () => {
        let btnActive = document.getElementById('clearFilters-' + field.Id + '-active')
        let btnDisabled = document.getElementById('clearFilters-' + field.Id + '-disabled')
        if (btnActive && btnDisabled) {
            if (activeFilterType.length > 0 || activeSortType.length > 0) {
                btnActive.classList.remove('clearFiltersBtnHidden');
                btnDisabled.classList.remove('clearFiltersBtnShowed');

                btnActive.classList.add('clearFiltersBtnShowed');
                btnDisabled.classList.add('clearFiltersBtnHidden');
            }
            else {
                btnDisabled.classList.remove('clearFiltersBtnHidden');
                btnActive.classList.remove('clearFiltersBtnShowed');

                btnDisabled.classList.add('clearFiltersBtnShowed');
                btnActive.classList.add('clearFiltersBtnHidden');
            }
        }
    }

    const saveFilter = (newFilter, fieldName, sortDirection) => { //Buffer function makes sure we only makes the necessary changes and nothing else
        let descSort = false;
        if (sortDirection === 'DESC') {
            descSort = true;
        }
        else if (sortDirection === '') {
            fieldName = activeSortType === fieldName ? '' : activeSortType;
            descSort = isDescendingSort;
        }
        setActiveSortType(fieldName);
        setIsDescendingSort(descSort)

        if (newFilter.length > 0) {
            setActiveFilterValues([...activeFilterValues.filter(f => f.column !== newFilter[0].column), newFilter[0]]);
            changeData([...activeFilterValues.filter(f => f.column !== newFilter[0].column), newFilter[0]], fieldName, descSort);
        }
        else {
            changeData(activeFilterValues.filter(f => f.column !== fieldName), fieldName, descSort);
        }
    }

    const changeData = (filters = undefined, sortBy = undefined, sortDesc = undefined) => {
        let filtered = field.Table.Rows
        if (filtered == null) {
            filtered = [];
        }

        if (filters) {
            for (let currentFilter of filters) {
                let columnIdFilter = field.Table.Columns.filter(c => c.Name === currentFilter.column)[0].Id;
                filtered = filtered.filter((row) => {
                    let filtered = row.Data.filter(r => r.ColumnId === columnIdFilter &&
                        (currentFilter.fieldValue.includes(r.Value) || (r.ColumnType === 'Date' && currentFilter.fieldValue.includes(dateFormat(r.Value)))
                        ));
                    return filtered.length > 0;
                })
            }
        }

        let columnSort = sortBy ? field.Table.Columns.filter(c => c.Name === sortBy)[0] : sortBy;
        if (columnSort) {
            let columnSortId = columnSort.Id;
            filtered = filtered.sort((a, b) => {
                let columnType = a.Data.filter(c => c.ColumnId === columnSortId)[0].ColumnType;
                let valueCompareA = a.Data.filter(c => c.ColumnId === columnSortId)[0].Value;
                let valueCompareB = b.Data.filter(c => c.ColumnId === columnSortId)[0].Value;

                if (isNumeric(valueCompareA) && isNumeric(valueCompareB)) {
                    if (sortDesc) {
                        return valueCompareB - valueCompareA
                    }
                    else {
                        return valueCompareA - valueCompareB
                    }
                }

                if (columnType === 'Date') {
                    let dayA = dayjs(valueCompareA, "MM/DD/YYYY");
                    let dayB = dayjs(valueCompareB, "MM/DD/YYYY");

                    let dateA = new Date(0);
                    let dateB = new Date(0);
                    if (dayA.isValid()) {
                        dateA = dayA.toDate();
                    }

                    if (dayB.isValid()) {
                        dateB = dayB.toDate();
                    }

                    if (sortDesc) {
                        return dateB - dateA
                    }
                    else {
                        return dateA - dateB
                    }
                }

                if (sortDesc) {
                    return ('' + valueCompareB).localeCompare('' + valueCompareA)
                }
                else {
                    return ('' + valueCompareA).localeCompare('' + valueCompareB)
                }
            })
        }
        else {
            filtered = filtered.sort((a, b) => {
                return a.Row - b.Row
            })
        }

        setFilteredSortedData(filtered)
    }

    const isNumeric = (n) => {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    const addNewRow = (a, b, c, d) => {
        clearAllFilters()
        setActiveSortType('');
        setIsDescendingSort(false);
        changeData(undefined, undefined, false);
        createNewDynamicTableRowHandler(a, b, c, d, isForm)
    }

    const handleChangeTable = (row, columnId, newValue) => {
        handleChange(row, columnId, newValue)
        const existingRow = filteredSortedData.find((r) => r.Row === row);

        if (!existingRow)
            return;

        existingRow.Data = existingRow.Data.map(oldData => oldData.ColumnId === columnId ? { ...oldData, Value: newValue } : oldData)
        setFilteredSortedData(filteredSortedData.map((prevRow) => prevRow.Row === row ? { ...prevRow, ...existingRow } : prevRow));
    }
    const passPayload = (label, table, filteredData) => {
        let columnId = table.Columns.filter(c => c.Name === label)[0].Id;
        let columnType = table.Columns.filter(c => c.Name === label)[0].Type;

        if (filteredData?.length === 0) {
            return [];
        }
        let ret = filteredData?.filter(row => row.IsVisible).map((row) => {
            return row.Data
        })
            .map((row) => {
                return row.filter(r => r.ColumnId === columnId).map((row) => {
                    return row.Value
                })
            })
            .map((row) => {
                return row[0]
            })
            .map((row) => {
                let newValue = row;

                if (columnType === 'Date') {
                    newValue = dateFormat(row);
                }
                let ret = {
                    FieldValue: newValue
                }
                return ret;
            }).filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.FieldValue === value.FieldValue
                ))
            ).sort((a, b) => {
                try {
                    return a.FieldValue.localeCompare(b.FieldValue)
                }
                catch {
                    console.log(a, b)
                }
            });
        return ret;
    }

    const dateFormat = (date) => {
        let ret = "";
        if (dayjs(date, "MM/DD/YYYY").isValid()) {
            ret = dayjs(date, "MM/DD/YYYY").format("MM/DD/YYYY");
        }

        return ret;
    }

    const fieldInputProps = {
        value: Data,
        onChange: handleChange,
        isInvalid,
        placeholder: Placeholder ?? getDefaultPlaceholderForFieldType(FieldType),
        // disables Enter from submitting forms on fields other than long text entries
        onKeyDown:
            FieldType !== FIELD_TYPES.multiText
                ? (e) => {
                    e.key === 'Enter' && e.preventDefault();
                }
                : null,
        disabled,
    };

    const addRow = (field) => {
        setDynamicFields((oldDynamicFields) =>
            oldDynamicFields.map((oldField) =>
                oldField.Id === field.Id
                    ? {
                        ...oldField,
                        Table: {
                            ...oldField.Table,
                            Rows: []
                        },
                    }
                    : oldField
            )
        );
    }

    const tableLock = (ColumnLockStatus, rowId) => {
        if (ColumnLockStatus === 4)
            return true;
        if (taskWithWorkflow.length == 0 || taskWithWorkflow?.CreatedById == user.userID || ColumnLockStatus === 1 || taskWithWorkflow.Permission === "Approve")
            return false;
        if (ColumnLockStatus == 2 && rowId == 0 && taskWithWorkflow.Permission === "Edit")    // or created user id is curent user id
            return false;
        return true;
    }

    const isDeleteRowDisabled = (row) => {
        let disableFlag = false;
        if (taskWithWorkflow.length == 0 || taskWithWorkflow?.CreatedById == user.userID)
            return disableFlag;

        row.forEach(r => {
            if ((r.ColumnLockStatus == 2 || r.ColumnLockStatus == 3) && r.Id !== 0 && taskWithWorkflow.Permission !== "Approve")    // or created user id is curent user id
                disableFlag = true;
        })
        return disableFlag;
    }

    const isAddRowDisabled = (columns) => {
        let disableFlag = true;
        if (taskWithWorkflow.length == 0 || taskWithWorkflow?.CreatedById == user.userID || taskWithWorkflow.Permission == "Approve")
            return !disableFlag;

        columns.forEach(c => {
            if ((c.LockStatus !== 3))    // or created user id is curent user id
                disableFlag = false;
        })
        return disableFlag;
    }

    // uses isInvalid prop on Form.Control
    // because isInvalid === true creates a red (!) sign whereas
    // isValid === true creates a green checkmark

    switch (FieldType) {
        case FIELD_TYPES.multiText:
            return (
                <Form.Control
                    {...fieldInputProps}
                    className="multitext-input"
                    as="textarea"
                    name="dynamic-fields-textarea"
                />
            );
        case FIELD_TYPES.dropDown:
            return (
                <Form.Control {...fieldInputProps} as="select">
                    <option value="">-Select-</option>
                    {LookupValues.map((lookupValue, idx) => (
                        <option value={lookupValue} key={idx}>
                            {lookupValue}
                        </option>
                    ))}
                </Form.Control>
            );
        case FIELD_TYPES.radioButtons:
            return (
                <TriyoForm.RadioButtons
                    className="options"
                    lookupValues={LookupValues}
                    value={fieldInputProps.value}
                    onChange={(e) => { handleChange({ target: { value: e } }) }}
                />
            )

        case FIELD_TYPES.checkbox:
            return (
                <TriyoForm.Checkboxes
                    className="options"
                    lookupValues={LookupValues}
                    value={fieldInputProps.value}
                    onChange={(e) => { handleChange({ target: { value: e } }) }}
                />
            )
        case FIELD_TYPES.toggle:
            return (
                <div className="toggle">
                    <TriyoForm.Label
                        label={field.Label}
                        required={false}
                    />
                    <TriyoForm.Toggle
                        checked={fieldInputProps.value === "selected"}
                        onChange={(e) => { handleChange({ target: { value: fieldInputProps.value === "selected" ? "not selected" : "selected" } }) }}
                    />
                </div>
            )
        case FIELD_TYPES.integer:
        case FIELD_TYPES.decimal:
            return (
                <Form.Control
                    {...fieldInputProps}
                    type={'number'}
                    // add empty listener to mouse wheel to allow scroll to change input
                    onWheel={() => { }}
                    onFocus={disableScroll}
                    onBlur={enableScroll}
                />
            );
        case FIELD_TYPES.date:
            return (
                <>
                    <FluentDatePicker
                        value={Data instanceof Date ? Data : (Data ? new Date(Data) : null)}
                        onChange={(date) => handleChange({ target: { value: date } })}
                        placeholder="Click to select a date"
                        disabled={disabled}
                        isInvalid={isInvalid}
                        dateFormatID="en-GB"
                    />
                    <Form.Control style={{ display: 'none' }} isInvalid={isInvalid} />
                </>
            );
        case FIELD_TYPES.table:
            return (
                <> <div className='dynamicTableContainer'>
                    <Table bordered className='rounded'>
                        <thead>
                            <tr style={{ height: 40 }}>
                                {
                                    field.Table.Columns.map((item) => {
                                        return {
                                            id: item.Id,
                                            name: item.Name,
                                            filterNames: item.Name,
                                            containerClassName: 'th-' + item.Name.replace(' ', '-').toLowerCase() + '-col',
                                            hasFilter: true,
                                            hasSort: true,
                                            filterType: item.Name,
                                            sortBy: item.Name,
                                            lockStatus: item.LockStatus
                                        }
                                    }).map((labelInfo, index) => {
                                        return (
                                            <th className='thDynamicTable' key={index}>
                                                <div className={`th-container th-container-center`}>
                                                    <div className='dynamicTableHeader'>
                                                        <div className={'lockButton noHover btn-icon1 lock ' + (labelInfo.lockStatus == 1 ? "lock-open" : labelInfo.lockStatus == 2 ? "lock-semi-open" : "lock-closed")}></div>
                                                        <OverlayTrigger
                                                            placement={"top"}
                                                            delay={{ show: 150, hide: 150 }}
                                                            overlay={
                                                                <Tooltip>
                                                                    {labelInfo.name}
                                                                </Tooltip>
                                                            }>
                                                            <div className='columnTooltip' title={labelInfo.name}>{labelInfo.name}</div>
                                                        </OverlayTrigger>

                                                        <div className='filterSortingContainer'>
                                                            {labelInfo.hasFilter && filteredSortedData &&
                                                                <FilterSortPanel
                                                                    key={labelInfo.id}
                                                                    parentFieldId={field.Id}
                                                                    fieldId={labelInfo.id}
                                                                    selected={activeFilterType.includes(labelInfo.filterType) ? selectedFilterRows.filter(r => r.Type === labelInfo.filterType).map(r => r.selectedRows)[0] : []}
                                                                    filterIcon={DropdownIcon} //Determines whether we use the grey filter icon for off, or blue filter icon for on
                                                                    header={labelInfo.filterNames}
                                                                    type={labelInfo.filterType}
                                                                    updateSelected={updateFilter}
                                                                    save={saveFilter}
                                                                    clear={clearFilter}
                                                                    selectedSortType={activeSortType}
                                                                    change={() => { }} //Doesn't do anything but needs to be defined because FilterPanel calls it
                                                                    close={() => { }} //Doesn't do anything but needs to be defined because FilterPanel calls it
                                                                    adminPayload={passPayload(labelInfo.name, field.Table, filteredSortedData)}>
                                                                </FilterSortPanel>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                        );
                                    })
                                }
                                <td key='row-delete'></td>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSortedData && filteredSortedData.map((row, index) => {
                                if (row.IsVisible === true) {
                                    return (
                                        <tr key={row.Row} style={{ height: 40 }}>
                                            {row.Data.map((rowData, index) => <td key={rowData.ColumnId + "_" + row.Row}>
                                                {rowData.ColumnType === 'Date' && <div className='w-100'>
                                                    <FluentDatePicker
                                                        value={rowData.Value && isDynamicTableFieldDataValid(field, row.Row, rowData.ColumnId) ? new Date(rowData.Value) : null}
                                                        onChange={(date) => handleChangeTable(row.Row, rowData.ColumnId, date)}
                                                        placeholder="MM-DD-YYYY"
                                                        disabled={tableLock(rowData.ColumnLockStatus, rowData.Id)}
                                                        isInvalid={Boolean(rowData.Value && !isDynamicTableFieldDataValid(field, row.Row, rowData.ColumnId))}
                                                        formatDate={(d) => d ? `${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}-${d.getFullYear()}` : ''}
                                                    />
                                                    <Form.Control style={{ display: 'none' }} isInvalid={rowData.Value && !isDynamicTableFieldDataValid(field, row.Row, rowData.ColumnId)} />
                                                </div>}
                                                {rowData.ColumnType === 'String' && <Form.Control
                                                    disabled={tableLock(rowData.ColumnLockStatus, rowData.Id)}
                                                    type={'text'}
                                                    value={rowData.Value}
                                                    placeholder={`Enter ${field.Table.Columns.find(col => col.Id == rowData.ColumnId)?.Name}`}
                                                    onChange={(e) => handleChangeTable(row.Row, rowData.ColumnId, e.target.value)}
                                                />}
                                                {rowData.ColumnType === 'Numeric' && <Form.Control
                                                    disabled={tableLock(rowData.ColumnLockStatus, rowData.Id)}
                                                    type={'number'}
                                                    step="any"
                                                    id={rowData.Id}
                                                    key={rowData.Id}
                                                    value={rowData.Value}
                                                    onWheel={() => { }}
                                                    //onBlur={enableScroll}
                                                    //onFocus={disableScroll}
                                                    placeholder="Enter number"
                                                    onChange={(e) => handleChangeTable(row.Row, rowData.ColumnId, e.target.value)}
                                                />}
                                                {rowData.ColumnType === 'Lookup' && <Form.Control as="select"
                                                    disabled={tableLock(rowData.ColumnLockStatus, rowData.Id)}
                                                    defaultValue={rowData.Value}
                                                    onChange={(e) => handleChangeTable(row.Row, rowData.ColumnId, e.target.value)}>
                                                    <option value="">-Select-</option>
                                                    {rowData.LookupValues?.map((lookupValue, idx) => (
                                                        <option value={lookupValue} key={idx}>
                                                            {lookupValue}
                                                        </option>
                                                    ))}
                                                </Form.Control>}
                                                {
                                                    rowData.ColumnType === 'Checkbox' && (<>
                                                        <Form.Control
                                                            disabled={tableLock(rowData.ColumnLockStatus, rowData.Id)}
                                                            className='m-auto'
                                                            type='checkbox'
                                                            checked={rowData.Value === "true"}
                                                            onChange={(e) => handleChangeTable(row.Row, rowData.ColumnId, e.target.checked.toString())}
                                                        />
                                                    </>
                                                    )
                                                }
                                            </td>)}
                                            {!disabledAddDelete && <td key={`row-delete-${index}`} className={isDeleteRowDisabled(row.Data) ? "text-center deleteContainer deleteDisabled" : "text-center deleteContainer"}>
                                                <div>
                                                    <Button
                                                        className='btn-icon1 delete-icon'
                                                        onClick={() => deleteDynamicTableRowHandler(field, row.Row, setDynamicFields, filteredSortedData, setFilteredSortedData, isForm)}
                                                        disabled={isDeleteRowDisabled(row.Data)}>
                                                    </Button>
                                                </div>
                                            </td>}
                                        </tr>
                                    );
                                }
                            })}
                        </tbody>
                        {!disabledAddDelete && <tfoot>
                            <tr>
                                <td colSpan={field.Table.Columns.length + 1} className='text-justify'>
                                    <Button variant='link' onClick={() => addNewRow(field, setDynamicFields, filteredSortedData, setFilteredSortedData)} disabled={isAddRowDisabled(field.Table.Columns)}>
                                        Add a row +
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>}
                    </Table>
                </div>
                </>

            );
        case FIELD_TYPES.file:
            return (
                <>
                    <CustomFileDropZone
                        defaultFiles={field?.Files ?? []}
                        onFilesChange={
                            async (files) => await handleChange({ target: { value: files } })
                        }
                        isDisabled={disabled}
                    />
                </>

            );
        case FIELD_TYPES.time:
        case FIELD_TYPES.singleText:
        default:
            return <Form.Control {...fieldInputProps} type={'text'} />;
    }
};

TaskDynamicFieldsInput.propTypes = {
    field: PropTypes.shape({
        Data: PropTypes.any,
        FieldType: PropTypes.oneOf(Object.values(FIELD_TYPES)).isRequired,
        LookupValues: PropTypes.array,
        Placeholder: PropTypes.string,
        touched: PropTypes.bool,
        Table: PropTypes.shape({
            Rows: PropTypes.array,
            Columns: PropTypes.arrayOf(
                PropTypes.shape({
                    Id: PropTypes.number,
                    Name: PropTypes.string,
                    LockStatus: PropTypes.number,
                })
            ),
        }),
        Files: PropTypes.array,
    }).isRequired,
    handleChange: PropTypes.func,
    disableErrors: PropTypes.bool,
    disabled: PropTypes.bool,
    isFromCreate: PropTypes.bool,
    setDynamicFields: PropTypes.func,
    taskWithWorkflow: PropTypes.array,
    disabledAddDelete: PropTypes.bool,
};

export default TaskDynamicFieldsInput;